import Vue from 'vue'
import App from './App.vue'
import './assets/styles/index.css'
import 'es6-promise/auto'
import VModal from 'vue-js-modal'
import Toasted from 'vue-toasted';
import { library } from '@fortawesome/fontawesome-svg-core'
import { faTrashAlt, faEdit, faPlus, faSignInAlt, faCheck, faHome, faArchive, faFileAlt, faSignOutAlt, faUsers, faUserTag, faEye, faEyeSlash, faMapMarkerAlt, faQuestionCircle, faGlobe, faTags, faUpload, faSearch, faFileExport, faLayerGroup, faBong, faBullseye, faFileDownload, faUniversity, faVectorSquare, faCube, faFileExcel, faFile, faImage, faSave, faUser, faSort, faPhotoVideo, faChartPie, faCaretDown, faCaretUp, faExclamationTriangle, faPalette, faDownload, faBook, faExternalLinkAlt, faCopy, faCaretLeft, faCaretRight, faExclamationCircle, faChevronLeft, faChevronRight, faFingerprint, faBars, faPlay, faLink, faTimes, faMap, faCaretSquareRight, faPause, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css';
import { LMap, LIcon, LTileLayer, LMarker, LPopup, LTooltip, LImageOverlay, LPolygon, LFeatureGroup, LWMSTileLayer, LControlLayers, LControlZoom, LGeoJson } from 'vue2-leaflet';
import { Icon } from 'leaflet';
import 'leaflet/dist/leaflet.css';
import VGeosearch from 'vue2-leaflet-geosearch';
import VueMeta from 'vue-meta'

import VSelect from '@/components/Select'
import VSelectMulti from '@/components/SelectMulti'

import Vidle from 'v-idle'

// import VueWorker from 'vue-worker'

import i18n from './i18n'
import router from './router'
import store from './store'

import plugins from '@/plugins'

library.add(faTrashAlt, faEdit, faPlus, faSignInAlt, faCheck, faHome, faArchive, faFileAlt, faSignOutAlt, faUsers, faUserTag, faEye, faEyeSlash, faMapMarkerAlt, faQuestionCircle, faGlobe, faTags, faUpload, faSearch, faFileExport, faLayerGroup, faBong, faBullseye, faFileDownload, faUniversity, faVectorSquare, faCube, faFileExcel, faFile, faImage, faSave, faUser, faSort, faPhotoVideo, faChartPie, faCaretDown, faCaretUp, faExclamationTriangle, faPalette, faDownload, faBook, faExternalLinkAlt, faSort, faCopy, faCaretLeft, faCaretRight, faExclamationCircle, faGlobe, faChevronLeft, faChevronRight, faFingerprint, faBars, faPlay, faLink, faTimes, faMap, faCaretSquareRight, faPause, faExclamationTriangle, faSpinner, faCaretLeft, faCaretRight)
Vue.component('f-icon', FontAwesomeIcon)
Vue.component('vue-select', VueSelect)
Vue.component('l-map', LMap);
Vue.component('l-icon', LIcon);
Vue.component('l-tile-layer', LTileLayer);
Vue.component('l-marker', LMarker);
Vue.component('l-polygon', LPolygon);
Vue.component('l-popup', LPopup);
Vue.component('l-tooltip', LTooltip);
Vue.component('l-feature-group', LFeatureGroup);
Vue.component('l-image-overlay', LImageOverlay);
Vue.component('l-wms-tile-layer', LWMSTileLayer);
Vue.component('l-control-layers', LControlLayers);
Vue.component('l-control-zoom', LControlZoom);
Vue.component('l-geo-json', LGeoJson);
Vue.component('l-geosearch', VGeosearch);

// Fix missing marker icon import
delete Icon.Default.prototype._getIconUrl;
Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

Vue.component('VSelect', VSelect)
Vue.component('VSelectMulti', VSelectMulti)

Vue.config.productionTip = false
Vue.use(VModal, { 
  dynamic: true, 
  //injectModalsContainer: true,
  dynamicDefaults: { clickToClose: false }
}) //  dialog: true
Vue.use(Toasted,{
  duration: 6000,
  keepOnHover: true,
  className: 'v-toaster',
  iconPack: 'fontawsome',
  theme: 'bubble'
})

Vue.use(VueMeta)
Vue.use(Vidle)
// Vue.use(VueWorker)

import VueGtag from "vue-gtag"
Vue.use(VueGtag, {
  config: { 
    id: process.env.VUE_APP_GOOGLE_GA_ID // Sostituisci con il tuo ID di misurazione GA4
  },
  // Parametri opzionali:
  // pageTrackerScreenviewEnabled: true // Se vuoi tracciare le route come "screen"
}, router);

// global access to plugins data
Vue.mixin({
  data: function() {
    return {
      get plugins() {
        return plugins;
      }
    }
  }
})

new Vue({
  i18n,
  router,
  store,
  render: h => h(App),
}).$mount('#app')